import {Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {IResponse} from "../../utils/interfaces/response";
import {
  IIncentive,
  IIncentiveHistory,
  IIncentiveReport,
  IIncentiveReportRequest
} from "../../utils/interfaces/incentive";

@Injectable({
  providedIn: 'root'
})
export class IncentiveService {

  private readonly URI_API = environment.apiConfig.uri + 'Incentive';

  constructor(private readonly httpClient: HttpClient) {
  }

  post(params: IIncentive): Observable<IResponse<string>> {
    return this.httpClient.post<IResponse<string>>(
      `${this.URI_API}/create`,
      params
    );
  }

  getHistoryPerBranchId(unitId: string): Observable<IResponse<IIncentiveHistory[]>> {
    return this.httpClient.get<IResponse<IIncentiveHistory[]>>(
      `${this.URI_API}/history/${unitId}`
    );
  }

  reportByBranchId(params: IIncentiveReportRequest): Observable<IResponse<IIncentiveReport[]>> {
    return this.httpClient.post<IResponse<IIncentiveReport[]>>(
      `${this.URI_API}/report`, params
    );

  }
}
